import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import { devices } from '../styles';

export const MediumSectionWidth = 944;

export const SectionWidth = 1040;

export const WideSection = styled(Box)`
  margin: 0 auto;

  @media (${devices.md}) {
    max-width: ${MediumSectionWidth}px;
  }

  @media (${devices.lg}) {
    max-width: 1140px;
  }

  @media (${devices.xl}) {
    max-width: 1240px;
  }
`;

export const Section = styled(Box)`
  margin: 0 auto;

  @media (${devices.md}) {
    max-width: ${MediumSectionWidth}px;
  }

  @media (${devices.lg}) {
    max-width: ${SectionWidth}px;
  }
`;
